// @ts-nocheck -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved.
import PropTypes from "prop-types";
import React from "react";
import { v4 } from "uuid";
import MuiBreadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import HomeIcon from "@mui/icons-material/Home";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Tooltip from "@mui/material/Tooltip";
import Link from "next/link";
import { getRouteParentsRecursively } from "@/utils/helpers";
import { useActiveRoute } from "@/hooks/useActiveRoute";
import { useDynamicTranslation } from "@/hooks/useDynamicTranslation";

export function Breadcrumbs({ routes }: any) {
  const { t } = useDynamicTranslation("routes");
  const { activeRoute } = useActiveRoute(routes);
  const theme = useTheme();

  const parentRouteList = getRouteParentsRecursively(activeRoute)
    .reverse()
    .filter((item: any) => item?.key !== "home");

  if (parentRouteList.length === 0) {
    return null;
  }

  return (
    <MuiBreadcrumbs
      sx={{ color: theme.palette.text.contrast }}
      aria-label="breadcrumb"
      separator={<NavigateNextIcon />}
    >
      <Link href="/">
        <Tooltip title={t("home")}>
          <HomeIcon sx={{ mr: 0.5, color: theme.palette.text.contrast }} />
        </Tooltip>
      </Link>
      {parentRouteList[0] ? (
        parentRouteList.map((route: any, index: any) => (
          <div key={v4()}>
            {index < parentRouteList.length - 1 ? (
              <Link href={route.toUrl()} style={{ textDecoration: "none", color: "inherit" }}>
                <Typography>{t(route?.key)}</Typography>
              </Link>
            ) : (
              <Typography>{t(route?.key)}</Typography>
            )}
          </div>
        ))
      ) : (
        <Typography>404</Typography>
      )}
    </MuiBreadcrumbs>
  );
}

Breadcrumbs.propTypes = {
  routes: PropTypes.object,
};
